import React, { useRef } from "react"
import Slider from "react-slick"
import { Href } from "../utils/helper"
import { storyblokEditable } from "gatsby-source-storyblok"

const AdCarousel = ({blok}) => {
  // console.log(blok.slides)

  let sliderRef = useRef(null)
  const next = () => {
    sliderRef.current.slickNext()
  }
  const previous = () => {
    sliderRef.current.slickPrev()
  }
  const PrevArrow = (props) => {
    const { className, style, onClick } = props
    return (
      <button className={className} onClick={onClick}
        style={{ ...style, display: "block", width: '30px', height: '30px'}} >
        <img className="lg:hidden absolute top-0 left-0" src="/icons/caret-left-sm.svg" alt="Prev button"/>
      </button>
    )
  }

  const NextArrow = (props) => {
    const { className, style, onClick } = props
    return (
      <button className={className} onClick={onClick}
        style={{ ...style, display: "block", width: '30px', height: '30px'}} >
        <img className="lg:hidden absolute top-0 right-0" src="/icons/caret-right-sm.svg" alt="Next button"/>
      </button>
    )
  }

  const settings = {
    autoplay: false,
    dots: false,
    infinite: true,
    arrows: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,

    responsive: [
      { breakpoint: 960, settings: { slidesToShow: 3, slidesToScroll: 3 } },
      { breakpoint: 720, settings: { slidesToShow: 2, slidesToScroll: 2, centerMode: true } },
      { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1, centerMode: true } },
    ]
  }

  const AdCarouselItem = ({item}) => (
    <a href={Href(item.ctaUrl)} className="">
      <img className="w-full h-[150px] object-contain items-center p-2" loading="lazy" src={`${item.image?.filename}/m/0x300`} alt={item.image?.alt} />
      <div className="text-center text-xs">{item.ctaText}</div>
    </a>
  )

  return (
    <>
    {blok.slides?.length > 0 && 
    <section className="py-4" {...storyblokEditable(blok)}>
      <div className="max-w-screen-lg mx-auto overflow-x-hidden px-10">
        <div className="slider-container">
          <Slider ref={sliderRef} {...settings} >{blok.slides?.map((item, index) => (<AdCarouselItem item={item} key={index}/> ))}</Slider>
        </div>
      </div>
    </section>
    }
    </>
  )
}
  
export default AdCarousel
